import { Stack, TextField } from '@mui/material';
import QuestionField from '../components/QuestionField';
import SelectInput from '../components/SelectInput';
import ConditionalBranch from '../components/ConditionalBranch';
import StepFooter from '../components/StepFooter';
import { REGRESSION_MODEL } from '../../registryChoices';

const defaultOutcome = {
  outcome_name: 'turnout',
  data_exclusions: '',
  missing_data: '',
  regression_model: '',
  regression_model_other: '',
  covariates: '',
  subgroup_analyses: '',
  additional_analyses: '',
};

const Step5Outcomes = ({ outcome, setOutcome, showErrors, onNext, onBack }) => {
  const current = outcome || defaultOutcome;
  const setField = (field, value) => setOutcome({ ...current, [field]: value });
  const otherMissing = showErrors && current.regression_model === 'other' && !current.regression_model_other.trim();

  const textarea = (field) => (
    <TextField
      hiddenLabel
      fullWidth
      multiline
      minRows={3}
      value={current[field]}
      onChange={(e) => setField(field, e.target.value)}
    />
  );

  return (
    <>
      <Stack spacing={3.25}>
        <QuestionField label="Describe how you will clean your data and deal with data exclusions.">
          {textarea('data_exclusions')}
        </QuestionField>

        <QuestionField label="Describe how you will deal with covariate and outcome missing data.">
          {textarea('missing_data')}
        </QuestionField>

        <QuestionField label="What regression model will you be using?">
          <SelectInput
            options={REGRESSION_MODEL}
            value={current.regression_model}
            onChange={(v) => setField('regression_model', v)}
          />
        </QuestionField>
        {current.regression_model === 'other' && (
          <ConditionalBranch>
            <QuestionField
              label="Please enter the regression model"
              required
              error={otherMissing ? 'This question is required.' : ''}
            >
              <TextField
                hiddenLabel
                fullWidth
                size="small"
                value={current.regression_model_other}
                onChange={(e) => setField('regression_model_other', e.target.value)}
                error={otherMissing}
              />
            </QuestionField>
          </ConditionalBranch>
        )}

        <QuestionField
          label="What variables will you include as covariates?"
          helper="Please list all and separate with a comma."
        >
          {textarea('covariates')}
        </QuestionField>

        <QuestionField label="Please list all planned subgroup analyses/heterogeneous treatment effects, separating with a comma.">
          <TextField
            hiddenLabel
            fullWidth
            size="small"
            value={current.subgroup_analyses}
            onChange={(e) => setField('subgroup_analyses', e.target.value)}
          />
        </QuestionField>

        <QuestionField
          label="What additional analyses are you planning to do with this outcome?"
          helper="For example, list any robustness checks you are planning."
        >
          {textarea('additional_analyses')}
        </QuestionField>
      </Stack>

      <StepFooter onBack={onBack} onNext={onNext} />
    </>
  );
};

export default Step5Outcomes;
